/*
 * SCRIPT FOR VISITOR LOCATION CHECK
 * Developer - Alexey Osipov (aosipovdev@gmail.com)
 *
 */

// Function to set location data in session storage
function setSessionLocationData(location) {
  sessionStorage.setItem("sessionUserLocation", JSON.stringify(location));
}

// Function to get location data from session storage
function getSessionLocationData() {
  return JSON.parse(sessionStorage.getItem("sessionUserLocation"));
}

// Function to update the announcement based on location
function updateAnnouncement(country) {
  const announcementElements = document.querySelectorAll('.announcement__bar');
  console.log("Visitor location is: " + country);

  if (country === "CH" || country === "UK") {
    announcementElements.forEach((element) => {
      console.log("Removing free shipment announcement");
      if (element.getAttribute("data-slide") === "text_G4cciq") {
        element.remove();
      }
    });

    // Remove free shipping message
    const freeShippingMessage = document.querySelector('.drawer__message.free-shipping');
    if (freeShippingMessage) {
      console.log("Removing free shipment cart progress bar and message");
      freeShippingMessage.remove();
    }
  }

  // Additional logic for other countries can be added here
}

// Function to fetch location from IPinfo API and store it in session storage
function fetchLocationFromAPI() {
  console.log("Fetching location from IPinfo API");
  fetch("https://ipinfo.io/json?token=a925c4745cbd30")
    .then((response) => response.json())
    .then((locationData) => {
      setSessionLocationData(locationData);
      updateAnnouncement(locationData.country);
    })
    .catch((error) => console.error("Error fetching location data:", error));
}

// Main function to check for location data in session storage or fetch from API
function checkAndFetchLocation() {
  const sessionData = getSessionLocationData();

  if (sessionData && sessionData.country) {
    console.log("Using session-stored location data");
    updateAnnouncement(sessionData.country);
  } else {
    // Fallback to API if no session-stored data is available
    fetchLocationFromAPI();
  }
}

// Call the function on page load
document.addEventListener("DOMContentLoaded", checkAndFetchLocation);
